import { Button, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Add } from '@icons/index';
import { useEffectFn } from '@ngneat/effects-hooks';
import { useObservable } from '@ngneat/react-rxjs';
import { clientDetailsQuery } from '@store/clients/details';
import { documentsQuery, documentsService, searchDocumentsEffect } from '@store/documents';
import { useNavigate } from 'react-router-dom';
import TabsComponent from '../../../../../components/tabs/Tabs.component';
import ClientDocument from './ClientDocuments/ClientDocument.screen';
import ClientExecutionDocument from './ClientExecutionDocuments/ExecutionDocument.screen';
import ClientIssueDocument from './ClientIssueDocument.screen.tsx/ClientIssueDocument.screen';
import { DocumentsStatus } from './DocumentStatus.enum';

const DocumentViews = {
  ADMIN: <ClientDocument />,
  EXECUTION: <ClientExecutionDocument />,
  ISSUE: <ClientIssueDocument />,
};

const DocumentsTab = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const searchDocuments = useEffectFn(searchDocumentsEffect);
  const [filters] = useObservable(documentsQuery.filters$);
  const [sortModel] = useObservable(documentsQuery.sort$);
  const [tablePagination] = useObservable(documentsQuery.pagination$);
  const [{ headOffice, loading }] = useObservable(clientDetailsQuery.clientDetails$);

  useEffect(() => {
    documentsService.setFilters('tableFilters')([
      {
        type: 'CLIENT_ORGANISATION',
        values: [{ label: headOffice.name, value: headOffice.id }],
        hide: true
      },
      {
        type: 'CLIENT_ORGANISATION_UNIT',
        values: [],
        hide: false
      },
      {
        type: 'SUPPLIER_ORGANISATION',
        values: [],
        hide: false
      },
      {
        type: 'SUPPLIER_ORGANISATION_UNIT',
        values: [],
        hide: false
      }
    ]);
  }
    , [headOffice]);


  useEffect(() => {
    searchDocuments({ filters, tablePagination, sort: sortModel });
  }, [filters, searchDocuments, sortModel, tablePagination]);

  const CurrentDocumentView: JSX.Element = DocumentViews[filters.documentKind as unknown as DocumentsStatus ?? 'ADMIN'];

  return (
    <Stack flex={1} spacing={2} mt="-35px">
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        <Stack direction="row" alignItems="center" spacing={2}>
          {!clientDetailsQuery.isArchived && (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button
                onClick={() => navigate('add')}
                variant="contained" color="primary"
                startIcon={<Add/>}>
                {t('clients.details.documents.addButton')}
              </Button>
            </Stack>
          )}
        </Stack>
      </Stack>

      <TabsComponent
        ariaLabel="secondary"
        handleChange={(value) => {
          documentsService.setFilters('documentKind')(DocumentsStatus.tabs[value]);
        }}
        value={DocumentsStatus.tabs.indexOf(filters.documentKind as unknown as DocumentsStatus ?? undefined)}
        tabs={[t('routes.adminDocuments'), t('routes.executions'), t('routes.noncompliance')]} />
      {CurrentDocumentView}
    </Stack >
  );
};

export default DocumentsTab;
